import { Environment } from './environment.interface';

export const environment: Environment = {
  mockUserInfo: null,

  omniCoreApiUrl: '/api/omni-core',
  signatureApiUrl: '/api/signature',
  portalApiUrl: '/api',

  monitoring: {
    sentryDsn:
      'https://c19b59ad8e81c0d8031df2c29f5e3f69@o4511077079515136.ingest.de.sentry.io/4511077081874512',
    hotjarJs: 'https://t.contentsquare.net/uxa/4e13d8f6052b3.js',
  },

  delays: {
    loadFullDashboardMs: 750,
    openParseRequestMs: 500,
    editLocationMs: 350,
    editEnergyInterfaceMs: 350,
    updateLocationMs: 500,
    updateEnergyInterfaceMs: 500,
    parseRequestSuccessPageMs: 500,
    createSupplierContractMs: 500,
  },

  articles: {
    meloMaloMeter:
      'https://stromify.de/wissenswertes/messlokation-marktlokation-zaehlernummer-so-nutzen-sie-sie-fuer-die',
    onboardingCompletedLearnMore: '/help-center/articles/contracts#section-upload',
    parseRequest: {
      headerBarInfoButton: '/help-center/articles/contracts#section-upload',
      sidebarNavInfoButton: '/help-center/articles/contracts#section-upload',
      generalInfoButton: '/help-center/articles/contracts#section-upload',
      uploadDocumentsInfoButton: '/help-center/articles/contracts#section-upload',
      summaryInfoButton: '/help-center/articles/contracts#section-upload',
    },
    contractCheck: {
      generalReasonsLink: '/help-center/articles/contracts#section-check',
    },
  },

  personalConsultants: {
    SIMON_ZOELLER: {
      name: 'Simon Zöller',
      image: '/profiles/simon-vor-gluehbirnen.jpeg',
      alt: 'Portrait von Simon Zöller vor Glühbirnen',
      externalCalendarName: 'Simon Zöller',
      externalCalendarLink: 'https://calendly.com/stromify/beratungsgesprach-mit-stromify',
      externalCalendarLinkPrivacyPolicy:
        'https://calendly.com/de/help/data-storage-and-international-data-transfers',
    },
    MATTHIAS_MOHR: {
      name: 'Matthias Mohr',
      image: '/profiles/matthias-mohr-linkedin.jpeg',
      alt: 'Portrait von Matthias Mohr',
      externalCalendarName: 'Simon Zöller',
      externalCalendarLink: 'https://calendly.com/stromify/beratungsgesprach-mit-stromify',
      externalCalendarLinkPrivacyPolicy:
        'https://calendly.com/de/help/data-storage-and-international-data-transfers',
    },
    HEIKO_TEIKEN: {
      name: 'Heiko Teiken',
      image: '/profiles/Heiko_2_small.jpg',
      alt: 'Portrait von Heiko Teiken',
      externalCalendarName: 'Simon Zöller',
      externalCalendarLink: 'https://calendly.com/stromify/beratungsgesprach-mit-stromify',
      externalCalendarLinkPrivacyPolicy:
        'https://calendly.com/de/help/data-storage-and-international-data-transfers',
    },
  },

  tutorialVideoEmbedLinks: {
    locations: 'https://www.youtube.com/embed/ZC-PJrGgHPY',
    energyInterfaces: 'https://www.youtube.com/embed/EWUCdpZQ9vA',
    supplierContracts: 'https://www.youtube.com/embed/kp-0UuC_2Rs',
    documents: 'https://www.youtube.com/embed/_u86wfIFnME',
    analysis: 'PLACEHOLDER_ANALYSIS',
  },

  allowedIFrameDomains: [
    '/api/omni-core',
    'https://dev-omni-core-files.s3.eu-central-1.amazonaws.com/',
    'https://prod-omni-core-files.s3.eu-central-1.amazonaws.com/',
  ],
  analysis: {
    price: {
      minDate: new Date(2023, 6, 25),
      maxYears: 4,
      ctKwhToEurMwhFactor: 10,
      queueDelayMs: 1000,
    },
  },

  links: {
    imprint: 'https://stromify.de/impressum',
    privacy: 'https://stromify.de/lumo-datenschutz',
    lumo: 'https://stromify.de/lumo',
    contact: 'https://stromify.de/kontakt',
  },

  demo: {
    registerLumoUrl: 'https://lumo.stromify.de',
  },
};
